export { SsrComponent } from './src/ssr-component/ssr-component';
